import {
  number,
  shape,
  string,
} from 'prop-types';

export const propTypes = {
  description: string,
  image: string,
  mapX: number,
  mapY: number,
  name: string,
};

export default shape(propTypes);